import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {HinweisboxTypeEnum} from '../../../shared/components/hinweisbox/hinweisbox-type.enum';
import {HinweisboxComponent} from '../../../shared/components/hinweisbox/hinweisbox.component';
import {I18NextPipe} from '@kokos-i18next';
import {UserAccountService} from '../../services/user-account.service';
import {environment} from '../../../../environments/environment';
import {ActingOnBehalfKontoStatusEnum} from "../../model/acting-on-behalf-konto-status.enum";
import i18next from "i18next";

@Component({
    selector: 'kokos-postfach-eingeschraenkt',
    standalone: true,
    imports: [HinweisboxComponent, I18NextPipe],
    templateUrl: './postfach-eingeschraenkt.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostfachEingeschraenktComponent implements OnInit {

    baseKey: string;

    hinweisboxType = HinweisboxTypeEnum;

    titleKey: string;
    firstInfoKey: string;
    secondInfoKey: string;

    linkOnlineKommunikation: string;

    private readonly userAccountService = inject(UserAccountService);


    ngOnInit(): void {
        this.setBaseKey();

        this.titleKey = `${this.baseKey}.title`;
        this.firstInfoKey = `${this.baseKey}.first`;
        this.secondInfoKey = `${this.baseKey}.second`;

        if (this.userAccountService.isStepUser() || this.userAccountService.isZuwanderungsinteressierter()) {
            this.linkOnlineKommunikation = environment.profilOnlinekommunikationUrl;

        } else if (this.userAccountService.isKindergeldFall()) {
            this.linkOnlineKommunikation = environment.famkaOnlinekommunikationUrl;
        }
    }

    get getLinkHtml(): string {
        if (this.baseKey !== 'mailbox.limited-use') {
            return '';
        }
        const onlineComLabel = i18next.t('mailbox.limited-use.online-communication');
        return `: <a href="${this.linkOnlineKommunikation}" target="_self">${onlineComLabel}</a>`;
    }

    private setBaseKey(): void {
        this.baseKey = this.userAccountService.getUserAccount().actingOnBehalfKontoStatus === ActingOnBehalfKontoStatusEnum.UNBEKANNT
            ? 'mailbox.limited-use-unknown'
            : 'mailbox.limited-use';
    }
}